import { IconButton as MuiIconButton } from "@mui/joy";

export default function IconButton(props: any) {
	const { sx: sxProp, ...rest } = props;
	return (
		<MuiIconButton
			variant="soft"
			color="primary"
			size="sm"
			{...rest}
			sx={{
				"--IconButton-radius": "4px",
				borderRadius: "4px",
				...sxProp,
			}}
		/>
	);
}
